var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.246,
    height: 66.396,
    viewBox: "0 0 71.246 66.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_021-box-5",
    "data-name": "021-box-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M75.908,54.243H72.315a3.538,3.538,0,0,0-3.377-2.6H65.1V42.269a.989.989,0,0,0-.483-.874L37.567,25.769a1,1,0,0,0-1,0L9.5,41.395a1.007,1.007,0,0,0-.5.874V73.52a1.01,1.01,0,0,0,.5.874L36.569,90.02a1.01,1.01,0,0,0,.5.135,1.062,1.062,0,0,0,.519-.135l14.242-8.215v5.938a4.275,4.275,0,0,0,4.311,4.286H75.908a4.3,4.3,0,0,0,4.339-4.286V58.6a4.356,4.356,0,0,0-4.339-4.353Zm-6.934-.577a1.465,1.465,0,0,1,1.465,1.465v.1a1.465,1.465,0,0,1-1.465,1.465H63.107a1.465,1.465,0,0,1-1.465-1.465v-.1a1.465,1.465,0,0,1,1.465-1.465Zm-31.9-25.857L48.319,34.3,23.276,48.761,12.031,42.268ZM36.114,87.4,11.019,72.937V44.015l25.095,14.46Zm.96-30.67L25.3,49.926,50.338,35.468l11.779,6.8ZM51.834,58.6V79.474L38.133,87.4V58.475l24.951-14.46v7.632h.031a3.538,3.538,0,0,0-3.377,2.6H56.145A4.332,4.332,0,0,0,51.834,58.6ZM78.227,87.743a2.278,2.278,0,0,1-2.32,2.267H56.145a2.254,2.254,0,0,1-2.292-2.267V58.6a2.311,2.311,0,0,1,2.292-2.334h3.632a3.453,3.453,0,0,0,3.338,2.452h5.823a3.453,3.453,0,0,0,3.338-2.452h3.632a2.334,2.334,0,0,1,2.32,2.334Z",
    transform: "translate(-9 -25.634)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M338,284.778h1.057a1.01,1.01,0,1,0,0-2.019h-.04v-2.74H341.8a.972.972,0,0,0,.96.682,1.012,1.012,0,0,0,1.015-1.007v-.679A1.023,1.023,0,0,0,342.758,278H338a1.007,1.007,0,0,0-1,1.014v4.756a1,1,0,0,0,1,1.008Z",
    transform: "translate(-289.695 -241.603)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M338.01,348.778h4.759a1.01,1.01,0,0,0,1.01-1.01V343.01a1.009,1.009,0,0,0-1.01-1.01H338.01a1.01,1.01,0,0,0-1.01,1.01v4.759A1.01,1.01,0,0,0,338.01,348.778Zm1.01-4.759h2.74v2.74h-2.74Z",
    transform: "translate(-289.695 -296.373)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M339.059,410.759h-.04v-2.74h2.73a1.015,1.015,0,1,0,2.03,0v-.973A1.053,1.053,0,0,0,342.758,406H338a1.037,1.037,0,0,0-1,1.048V411.8a.974.974,0,0,0,1,.974h1.057a1.01,1.01,0,0,0,0-2.019Z",
    transform: "translate(-289.694 -351.142)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M359.934,284.835l-2.957,2.957-.9-.9a1.01,1.01,0,0,0-1.428,1.428l1.613,1.613a1.01,1.01,0,0,0,1.428,0l3.671-3.671a1.01,1.01,0,1,0-1.428-1.428Z",
    transform: "translate(-304.546 -247.199)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M359.934,414.084l-2.957,2.957-.9-.9a1.01,1.01,0,0,0-1.428,1.428l1.613,1.613a1.01,1.01,0,0,0,1.428,0l3.671-3.671a1.01,1.01,0,0,0-1.428-1.428Z",
    transform: "translate(-304.546 -357.807)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M421.242,295H414.9a1.01,1.01,0,0,0,0,2.019h6.341a1.01,1.01,0,1,0,0-2.019Z",
    transform: "translate(-355.496 -256.151)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M421.242,359H414.9a1.01,1.01,0,0,0,0,2.019h6.341a1.01,1.01,0,1,0,0-2.019Z",
    transform: "translate(-355.496 -310.921)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M421.242,423H414.9a1.01,1.01,0,0,0,0,2.019h6.341a1.01,1.01,0,0,0,0-2.019Z",
    transform: "translate(-355.496 -365.69)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox1);
export default __webpack_public_path__ + "static/media/box1.f30c72f870e8e07eef875b93735290c8.svg";
export { ForwardRef as ReactComponent };